import React from "react";
const questions = (props) => {
  let questArray = [
    "What happened after a booking request?",
    "Why are tutors expected to respond within 24 hours?",
    "As a tutor can I declined lessons enquiries or requests",
  ];
  return (
    <React.Fragment>
      <div className="frequent-questions">
        {/* header */}
        <h4 className="h4 py-3">Frequently asked questions</h4>
        {/* sub header */}
        {questArray.map((question) => (
          <div>
            <div className="quest-div">{question}</div>
            {/* content area*/}
            <p className="questions">
              This is what happens for potential bookings requested have been
              submitted to tutors. This is what bookings requested have been
              submitted to tutors. This is what happens
            </p>
            <a href="#" className="anchor green-txt">
              Read more
            </a>
            <hr/>
          </div>
        ))}
      </div>

      <div className="py-4">
        <a href="#" className="py-3 green-txt">
          See more articles
        </a>
      </div>
    </React.Fragment>
  );
};
export default questions;
